import { TransactionSuccessToast } from "@/components";
import type { TransactionHash, TokenId } from "@/types";
import { ToastDetailRow } from "@/components";

interface RedeemSuccessToastProps {
    redeemAmount: number;
    redeemTokenId: TokenId;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function RedeemSuccessToast({ redeemAmount, redeemTokenId, transactionHash, onClose }: RedeemSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Redemption successful" transactionHash={transactionHash} onClose={onClose}>
            <ToastDetailRow label="Redeemed" amount={redeemAmount} tokenId={redeemTokenId} />
        </TransactionSuccessToast>
    );
}
